import React, { useState } from 'react';
import ContactLists from './contactlists';
import styles from "./scss/leftsidebar.module.scss";
import { contactwindowDetails, initialStateModel, leftsideChats, recentChatSocketReducerStateModel } from "../../../models/model";
import { useSelector } from 'react-redux';
import { URChatLeftSkeleton } from '../../../shared/widgets/skeletonLoading/chatLeftSkeleton';
import { URAvatarGroup } from '../../../shared/widgets/avatarGroup';
import store from '../../../context/store/store';
import { URStatusDot } from '../../../shared/widgets/avatarGroup/statusDot';
import { userStatusColor } from '../../../base/callService/common';
import _ from 'lodash';

type setdefaultContactsProps={
  defaultContacts:any
  chats:string;
  updateChatIndexData: any;
  recentAllList?:any;
}

type RecentChatState={
  limit:any;
  offset:any;
  count:any;
}


export default function Recentchats({defaultContacts,chats,updateChatIndexData,recentAllList}:setdefaultContactsProps) {
  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer); 
  let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
  let {recentContact, isRecentchatLoader,
    recentPageLoad,  isRecentPaginationStop} = contactList;
  const [pagination, setPagination] =  useState<RecentChatState>({limit:20,offset:0,count:""});
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState); 
  const savedList: recentChatSocketReducerStateModel = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let {  contactReducer } = allReducer;
  let workContact = contactReducer?.workContactsnew;
  let teamContact = contactReducer?.teamContacsnew;
  let {savedChatList} = savedList;
  const handleScroll=(e:any)=>{
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if(bottom && isRecentPaginationStop){
      // ChatService.recentPagination(pagination.limit,pagination.offset);
      setPagination({...pagination,limit:pagination.limit+10, offset:pagination.offset});
    }
  };
  let totalUnreadCount = 0;
  const filteredContacts = _.filter(defaultContacts?.searchUnread, (value)=>{
    let contactsDetail = value?.type===1? workContact[value?.to]:teamContact["con"+value?.chatId];
    if(contactsDetail!==undefined){
      totalUnreadCount = totalUnreadCount + value?.unreadCount;
    }
    return contactsDetail!==undefined;
  });
  return (
    <>
      <div className={styles.middlelayermiddle}>
       { contactWindowDetails?.caller_id && chatSocketMessage?.messageList.length === 0 &&_.isUndefined(chatSocketMessage.messageLoading)&&
       <>
        <div className={styles.profilelists} >
          <div className={styles.profileDetailspop}>
              <span title="View profile">
                <div >
                    <URAvatarGroup  className="lefts size38 one"
                    profileInfo={
                    (contactWindowDetails?.ImageURL !== null && contactWindowDetails?.ImageURL !== "") ?
                    (<>
                    <img src={contactWindowDetails?.ImageURL} alt="" />
                    <URStatusDot
                      className={userStatusColor(contactWindowDetails?.user_status,'small')}/></>) :
                    (<>
                    <span>{contactWindowDetails?.caller_id?.charAt(0).toUpperCase()} </span>
                    <URStatusDot
                      className={userStatusColor(contactWindowDetails?.user_status,'small')}/>
                    </>)
                    } /> 
                </div>
              </span>
          </div>
          <div className={styles.middle}>
              <h4>
                <div className="texthighlight2">{contactWindowDetails.caller_id}
                
                </div>
              </h4>
              <p title="View Chat">New Conversation</p>
          </div>
        </div>
        </> }
       
        {/* {( defaultContacts.searchArchive?.length>= 0 || defaultContacts.draftContacts?.length >=0 || filteredContacts?.length>=0 || defaultContacts?.pinnedContacts.length>=0 || defaultContacts?.favouriteContacts.length>=0) && ( */}
        <div className={styles.recentTitle}>
              Recent chat
        </div>
         {/* )} */}
        <div className={`${styles.scrolllayerleft} callfadein`} onScroll={handleScroll} id="recentchatSec">
          <ContactLists chats={chats} isSearch={defaultContacts.isSearch} 
          updateChatIndex={updateChatIndexData}
            searchContactList={recentAllList} contactList={recentContact} isLoader={isRecentchatLoader} searchText={defaultContacts.searchText} pinnedList={defaultContacts}></ContactLists>
          { recentPageLoad && ([1].map((item: any, index: any) => (
            <URChatLeftSkeleton width={100} key={index} />)))}
        </div>
      </div>
    </>
  );
}
